import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationPage as ConfirmationPagePk } from 'omni-package-react-core';
import { P, clearResourceDataByName } from 'ia-react-core';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { StyledText } from './UsernameConfirmationPage.styles';
import { AccountResourceInfo } from '../../components/AccountResource';

export interface UsernameConfirmationPageProps {
  returnPage: string;
}

const UsernameConfirmationPage: FC<UsernameConfirmationPageProps> = ({ returnPage }) => {
  const { t } = useTranslation('UsernameConfirmationPage');
  const title = t('title');
  const { state }: { state: { data: { newUsername: string } } } = useLocation();
  const newUsername = state?.data?.newUsername;

  const children = <P>{t('information')} <StyledText data-testid="newUsername">{newUsername}</StyledText></P>;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearResourceDataByName(AccountResourceInfo.name));
  }, [dispatch]);

  return (
    <ConfirmationPagePk title={title} redirect={returnPage}>
      {children}
    </ConfirmationPagePk>
  );
};
export default UsernameConfirmationPage;
